import { render } from "./CheckUpdateModal.vue?vue&type=template&id=215cc859&scoped=true"
import script from "./CheckUpdateModal.vue?vue&type=script&lang=js"
export * from "./CheckUpdateModal.vue?vue&type=script&lang=js"

import "./CheckUpdateModal.vue?vue&type=style&index=0&id=215cc859&scoped=true&lang=css"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215cc859"]])

export default __exports__